import {
  CheckCircleIcon,
  ClockIcon,
  XCircleIcon,
} from "@heroicons/react/16/solid"
import clsx from "clsx"
import type { ReactNode } from "react"

const Badge = ({
  variant,
  className,
  children,
  hideIcon = false,
}: {
  variant: "error" | "info" | "success" | "neutral"
  className?: string
  children: ReactNode
  hideIcon?: boolean
}) => (
  <div
    className={clsx(
      "-outline-offset-1 flex items-center gap-x-1 whitespace-nowrap rounded-lg px-2 py-1.5 font-semibold text-xs/none outline outline-transparent",
      {
        "bg-red-500/15 text-red-700 dark:text-red-400": variant === "error",
        "bg-blue-500/15 text-blue-700 dark:text-blue-300": variant === "info",
        "bg-green-600/15 text-green-800 dark:text-green-500":
          variant === "success",
        "bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300":
          variant === "neutral",
      },
      className
    )}
  >
    {!hideIcon && variant === "error" && (
      <XCircleIcon className="size-3 text-red-500 dark:text-red-400" />
    )}
    {!hideIcon && variant === "info" && (
      <ClockIcon className="size-3 text-blue-500 dark:text-blue-400" />
    )}
    {!hideIcon && variant === "success" && (
      <CheckCircleIcon className="size-3 text-green-700 dark:text-green-500" />
    )}
    {children}
  </div>
)

export default Badge
